<template>
  <div class="interiorContent">
    <div class="searchBox">
      <el-input
          style="width: 55%"
          size="small"
          placeholder="输入姓名/手机号进行过滤"
          v-model="filterText">
      </el-input>
    </div>
   <div class="contentWarp">
     <div class="leftWarp">
       <div class="title">待选人员</div>
       <el-tree
           :key="updateTreeKey"
           ref="tree"
           :data="data"
           :props="defaultProps"
           node-key="remark"
           :filter-node-method="filterNode"
           @check-change="checkChange"
           @check="check"
           default-expand-all
           show-checkbox>
          <span class="custom-tree-node" slot-scope="{  data }">
            <span v-if="data.type === 1">{{ data.deptName }}</span>
            <span v-else>{{ `${data.deptName}(${data.deptCode})` }}</span>
          </span>
       </el-tree>
     </div>

     <div class="rightWarp">
       <div class="titleAddMore">
         <div class="title">已选人员</div>
         <el-button type="text" class="addMore" @click="openAddMorePerson" v-if="checkAuth('invitation')">添加更多人员</el-button>
       </div>
       <div class="checkList">
         <div v-for="item in noRepcheckData" :key="item.userId" class="item">
           <div class="name">{{`${item.name}(${item.phone})`}}</div>
           <div><i class="el-icon-close" @click="delCheckPerson(item)"></i></div>
         </div>
       </div>
     </div>
   </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import prjMemberService from '@/xgzdService/prjMember-service'
import {checkAuth} from '../../utils'
export default {
  name:'interior',

  data () {
    return {
      filterText:'',
      data:[],
      defaultProps: {
        children: 'children',
        label: 'deptName',
        isLeaf:function (data) {
          return !!data.userId
        }
      },
      checkData:[],
      updateTreeKey:0,
      propsMap: {
        name: 'deptName',
        phone: 'deptCode'
      }
    }
  },

  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },

  computed: {
    ...mapState({
      enterpriseId: state => state.enterprise.enterpriseId,
    }),

    noRepcheckData () {
      let obj = {}
      return this.checkData.reduce((cur,next) => {
        obj[next.userId] ? "" : obj[next.userId] = true && cur.push(next);
        return cur;
      },[])
    },
  },

  created () {
    this.queryInteriorRoleTree()
  },

  methods : {
    checkAuth,
    queryInteriorRoleTree () {
      const {enterpriseId} = this
      prjMemberService.queryInteriorRoleTree(enterpriseId)
      .then(res => {
        if (res.result === '0') {
          this.data = res.data || []
        }
      })
    },

    check (data,{checkedNodes}) {
      const filterArr = checkedNodes.filter(item => item.type === 2) || []
      const mapArr = filterArr.map(item => ({userId:item.deptId,name:item.deptName,phone:item.deptCode,remark:item.remark}))
      this.checkData = mapArr
    },

    checkChange (data, checked, indeterminate) {
      if (data.type === 2 && !checked) {
        this.delCheckPerson({ userId:data.deptId,remark:data.remark })
      }
    },

    delCheckPerson (item) {
      const filterArr = this.checkData.filter(person => person.userId === item.userId)
      filterArr.forEach(item => {
        const index = this.checkData.findIndex(person => person.remark === item.remark)
        if (index > -1) {
          this.checkData.splice(index,1)
          this.$refs.tree.setChecked(item.remark,false)
        }
      })
    },

    filterNode(value, data) {
      if (!value) return true;
      if (data.type === 1) return false
      return data[this.propsMap.name].indexOf(value) !== -1 || data[this.propsMap.phone].indexOf(value) !== -1
    },

    openAddMorePerson () {
      this.$router.push({path:'/project-invitePersonPlan',query:{addType:0}})
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .interiorContent
    width 100%
    height 100%
    padding-top 10px
    box-sizing border-box
    .contentWarp
      display flex
      align-items center
      justify-content space-between
      height calc(100% - 42px)
      padding-top 10px
      .leftWarp
        width 55%
        height 100%
        .title
          height 32px
          line-height 32px
          padding 0 5px
          box-sizing border-box
          font-size 16px
        /deep/ .el-tree
                height calc(100% - 32px)
                overflow-y auto
                border: 1px solid #D4D9EC;
      .rightWarp
        width 40%
        height 100%
        .titleAddMore
          height 32px
          display flex
          align-items center
          justify-content space-between
          padding 0 5px
          box-sizing border-box
          .title
            font-size 16px
         .checkList
            height calc(100% - 32px)
            overflow-y auto
            border: 1px solid #D4D9EC;
            .item
              display flex
              align-items center
              justify-content space-between
              border-bottom 1px solid rgba(46, 91, 255, 0.1);
              height 50px
              padding 0 20px
              box-sizing border-box
              i
                font-size 16px
                cursor pointer
</style>
